// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialMediaFooter-module--wrapper--23157","iconLink":"SocialMediaFooter-module--iconLink--ff34a"};